import './styles/googleAds2.css'

export default function GoogleAdPlaceholder2() {
  return (
    <>
      <div className="google-ad2">
        {/* <div className="container-content"> */}
          <div className="ad-wrapper2">
            <h1>Google Ad</h1>
          </div>
        {/* </div> */}
      </div>
    </>
  );
}
